import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { ServiceProviderForm } from 'Services/ServiceProviderManagement/Features/ServiceProvider/Components/ServiceProviderForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function ServiceProviderCreatePage() {
  const baseUrl = `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/service-providers`
  const previousLocation = usePreviousLocation(baseUrl)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SERVICE_PROVIDER_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Service providers`,
      link: baseUrl
    },
    {
      title: t`Create new service provider`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new service provider`}</PageTitle>
        </Grid>
      </Grid>
      <ServiceProviderForm successBaseUrl={previousLocation} />
    </Box>
  )
}
